'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactGoogleMaps = require('react-google-maps');

var _MapFilter = require('./MapFilter');

var _MapFilter2 = _interopRequireDefault(_MapFilter);

var _InfoBox = require('./InfoBox');

var _InfoBox2 = _interopRequireDefault(_InfoBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StoreLocatorMap = (0, _reactGoogleMaps.withScriptjs)((0, _reactGoogleMaps.withGoogleMap)(function (props) {
    (0, _react.useEffect)(function () {
        if (props.mapBounds === null) props.centerMap();
    });

    return _react2.default.createElement(
        _reactGoogleMaps.GoogleMap,
        {
            ref: function ref(map) {
                if (map) props.setMap(map);
            },
            defaultZoom: 14,
            defaultCenter: props.mapCenter,
            defaultOptions: {
                styles: props.mapStyles,
                addressControl: false,
                linksControl: false,
                panControl: false,
                streetViewControl: false,
                zoomControl: true,
                draggable: true,
                mapTypeControl: false,
                disableDoubleClickZoom: true,
                fullscreenControl: false,
                scrollwheel: false
            }
        },
        props.markers.map(function (marker) {
            return _react2.default.createElement(_reactGoogleMaps.Marker, {
                key: marker.id,
                position: marker.location,
                onClick: function onClick() {
                    return props.getAllDirections(marker, 'DRIVING');
                },
                icon: {
                    path: window.google.maps.SymbolPath.CIRCLE,
                    fillColor: marker.marker_color,
                    fillOpacity: 1,
                    // anchor: new window.google.maps.Point(17, 21),
                    strokeWeight: 0,
                    scale: 10
                }
            });
        }),
        _react2.default.createElement(_reactGoogleMaps.Marker, {
            position: props.mapCenter
            // icon={props.centerMarker}
            , icon: {
                url: props.centerMarker,
                anchor: new window.google.maps.Point(50, 80)
            }
            // icon={`${props.stylesheetDirectory}/assets/images/map-marker-center.png`}
        }),
        props.directions && _react2.default.createElement(_reactGoogleMaps.DirectionsRenderer, { directions: props.directions }),
        _react2.default.createElement(_InfoBox2.default, {
            infoBoxIsClickable: props.infoBoxIsClickable,
            marker: props.marker,
            travelModes: props.travelModes,
            travelMode: props.travelMode,
            getAllDirections: props.getAllDirections,
            getDrivingDirections: props.getDrivingDirections,
            getWalkingDirections: props.getWalkingDirections,
            getBicyclingDirections: props.getBicyclingDirections,
            clearDirections: props.clearDirections,
            stylesheetDirectory: props.stylesheetDirectory,
            directions: props.directions,
            drivingDirections: props.drivingDirections,
            bicyclingDirections: props.bicyclingDirections,
            walkingDirections: props.walkingDirections,
            infoBoxIsOpen: props.infoBoxIsOpen
        }),
        _react2.default.createElement(_MapFilter2.default, {
            categories: props.categories,
            activeCategories: props.activeCategories,
            setCategory: props.setCategory,
            download: props.download
        })
    );
}));

StoreLocatorMap.propTypes = {
    mapCenter: _propTypes2.default.object,
    centerMarker: _propTypes2.default.string,
    mapStyles: _propTypes2.default.array,
    marker: _propTypes2.default.object,
    markers: _propTypes2.default.array,
    getAllDirections: _propTypes2.default.func,
    getDrivingDirections: _propTypes2.default.func,
    getWalkingDirections: _propTypes2.default.func,
    getBicyclingDirections: _propTypes2.default.func,
    clearDirections: _propTypes2.default.func,
    activeCategories: _propTypes2.default.array,
    categories: _propTypes2.default.array,
    setCategory: _propTypes2.default.func,
    directions: _propTypes2.default.object,
    drivingDirections: _propTypes2.default.object,
    bicyclingDirections: _propTypes2.default.object,
    walkingDirections: _propTypes2.default.object,
    travelMode: _propTypes2.default.string,
    travelModes: _propTypes2.default.array,
    stylesheetDirectory: _propTypes2.default.string,
    infoBoxIsOpen: _propTypes2.default.bool,
    infoBoxIsClickable: _propTypes2.default.bool,
    centerMap: _propTypes2.default.func,
    download: _propTypes2.default.any
};

exports.default = StoreLocatorMap;


// WEBPACK FOOTER //
// ./scripts/react/storelocator/StoreLocatorMap.js